export interface EventData<T = any> {
  readonly type: EVENT_TYPE;
  readonly timestamp: string;
  readonly content: T;
}

export type EventCallback<T = any> = (data: EventData<T>) => void;

export interface InitializeOptions {
  readonly token: string;
  readonly humanInTheLoopApiURL: string;
  readonly serviceDiscoveryURL: string;
  readonly emBusURL: string;
  readonly isDebug?: boolean;
  /** WebSocket client can output a lot more logs if needed */
  readonly isWSDebug?: boolean;
}

/* eslint-disable-next-line */
export enum EVENT_TYPE {
  INITIALIZE = 'INITIALIZE',
  INITIALIZE_STATUS_PINGS = 'INITIALIZE_STATUS_PINGS',
  TOKEN_CHANGE = 'TOKEN_CHANGE',
  EMIT_CONNECTION_ID = 'EMIT_CONNECTION_ID',
  PING_STATUS = 'PING_STATUS',
  APP_ACTION = 'APP_ACTION',
  WS_CONNECT = 'WS_CONNECT',
  WS_PING = 'WS_PING',
  WS_CLOSE = 'WS_CLOSE',
  WS_ERROR = 'WS_ERROR',
  SEND_WS_MESSAGE = 'SEND_WS_MESSAGE',
}
